import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["value", "selected"]


export default /*@__PURE__*/_defineComponent({
  __name: 'DropDown',
  props: {
  placeholder: {
    type: String,
    default: 'Select'
  },
  items: {
    type: Array as () => { value: string; label: string; selected: string }[],
    required: true
  },
  selectType: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("select", {
    class: _normalizeClass(__props.selectType),
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChange', $event)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
      return (_openBlock(), _createElementBlock("option", {
        key: index,
        value: item.value,
        selected: item.value === item.selected ? true : false
      }, _toDisplayString(__props.selectType == 'voice' ? index + 1 + '. ' + item.label : item.label), 9, _hoisted_1))
    }), 128))
  ], 34))
}
}

})